import { css } from '@compiled/react';
import { Tag } from '@atlassian/learning-components';
import { token } from '@atlaskit/tokens';
import React from 'react';

interface TagListProps {
  taxonomyList: string[];
  isLarge: boolean;
}

export const TagList: React.FC<TagListProps> = ({ taxonomyList, isLarge }) => {
  if (!taxonomyList || !taxonomyList.length) {
    return null;
  }

  return (
    <div css={css({ display: 'flex', flexWrap: 'wrap', gap: token('space.100') })} data-testid="tag-list">
      {taxonomyList.map((tag) => (
        <Tag isLarge={isLarge} key={tag} label={tag} />
      ))}
    </div>
  );
};
